import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, withStyles, useTheme } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import IconButton from '@material-ui/core/IconButton';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import LastPageIcon from '@material-ui/icons/LastPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import Paper from '@material-ui/core/Paper';
import TextField from "@material-ui/core/TextField";
import { isNotEmpty } from '../..//../../utils/Validator';
import { parseDate } from '../../../../utils/Utils';
import Button from "@material-ui/core/Button";
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import UndoIcon from '@material-ui/icons/Undo';
import RestoreIcon from '@material-ui/icons/Restore';
import VisibilityIcon from '@material-ui/icons/Visibility';
import CloseIcon from '@material-ui/icons/Close';
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Grid from '@material-ui/core/Grid';
import { Typography, Tooltip, Box } from "@material-ui/core";
import MenuItem from '@material-ui/core/MenuItem';
import ProviderService from "../../../../Services/ProviderService";
import ConfirmationDialog from "../ConfirmationDialog";


function desc(a, b, orderBy) {
    let c = a[orderBy];
    let d = b[orderBy];

    if (isNotEmpty(c)) {
        if (typeof c === "string") {
            c = c.toUpperCase();
        } else if (c instanceof Date) {
            c = parseDate(c);
        }
    } else {
        c = "";
    }

    if (isNotEmpty(d)) {
        if (typeof d === "string") {
            d = d.toUpperCase();
        } else if (d instanceof Date) {
            d = parseDate(d);
        }
    } else {
        d = "";
    }

    if (d < c) {
        return -1;
    }

    if (d > c) {
        return 1;
    }

    return 0;
}

function stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
    return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

// Table header cells with percentage-based widths
const headCells = [
    { id: 'ltrLicenseType', numeric: false, disablePadding: true, label: 'Type', filterLable: ' Type', width: '15%' },
    { id: 'plicStateCode', numeric: false, disablePadding: true, label: 'State', filterLable: ' State', width: '10%' },
    { id: 'plicLicenseNbr', numeric: false, disablePadding: true, label: 'License Number', filterLable: 'License Number', width: '15%' },
    { id: 'plicIssueDate', numeric: false, disablePadding: true, label: 'Issue Date ', filterLable: 'Issue Date', width: '15%' },
    { id: 'plicExpirationDate', numeric: false, disablePadding: true, label: 'Expiration Date', filterLable: 'Expiration Date', width: '15%' },
    { id: 'lsrStatus', numeric: false, disablePadding: true, label: 'Status', filterLable: 'Status', width: '15%' },
    { id: 'ACTIONS', numeric: false, disablePadding: true, label: 'Actions', filterLable: 'Actions', width: '15%' }
];

// EnhancedTableHead component
function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort, onRequestFilter } = props;
    const createSortHandler = property => event => {
        onRequestSort(event, property);
    };
    const onFilter = property => event => {
        onRequestFilter(event.target.value, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells.map(headCell => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.numeric ? 'right' : 'left'}
                        sortDirection={orderBy === headCell.id ? order : false}
                        style={{ width: headCell.width }}
                        autoFocus={headCell.id === 'ltrLicenseType'}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id && headCell.id !== 'ACTIONS'}
                            direction={order}
                            onClick={headCell.id !== 'ACTIONS' ? createSortHandler(headCell.id) : null}
                            disabled={headCell.id === 'ACTIONS'}
                        >
                            <div>
                                <div>
                                    {headCell.label}
                                    {orderBy === headCell.id ? (
                                        <span className={classes.visuallyHidden}>
                                            {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                        </span>) : null}
                                </div>
                            </div>
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
            <TableRow className='filter-row'>
                {headCells.map(headCell => (
                    <TableCell
                        key={headCell.id + 1}
                        padding="none"
                        style={{ maxWidth: headCell.width, padding: 0 }}
                        autoFocus={headCell.id === 'ltrLicenseType'}
                    >
                        {headCell.id !== 'ACTIONS' && (
                            <div style={{ paddingRight: '0', verticalAlign: 'bottom' }}>
                                <TextField
                                    id="filterId"
                                    fullWidth
                                    autoFocus={headCell.id === 'ltrLicenseType'}
                                    style={{ height: '.7', margin: 0 }}
                                    placeholder="Filter..."
                                    margin="none"
                                    variant="outlined"
                                    size="small"
                                    onChange={onFilter(headCell.id)}
                                    InputProps={{
                                        style: { backgroundColor: 'transparent' }
                                    }}
                                />
                            </div>
                        )}
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onRequestFilter: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

// TablePaginationActions component
const useStyles1 = makeStyles(theme => ({
    root: {
        flexShrink: 0,
        marginLeft: theme.spacing(2.5),
    },
}));

function TablePaginationActions(props) {
    const classes = useStyles1();
    const theme = useTheme();

    const { count, page, rowsPerPage, onChangePage } = props;

    const handleFirstPageButtonClick = event => {
        onChangePage(event, 0);
    };

    const handleBackButtonClick = event => {
        onChangePage(event, page - 1);
    };

    const handleNextButtonClick = event => {
        onChangePage(event, page + 1);
    };

    const handleLastPageButtonClick = event => {
        onChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <div className={classes.root}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </div>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onChangePage: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

// Updated styles to match specialty and location edit components
const useStyles = theme => ({
    root: {
        width: '100%',
        marginTop: 0,
        maxWidth: '100%',
        padding: 0,
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2),
        maxWidth: '100%',
        padding: 0,
    },
    table: {
        minWidth: 450,
        width: '100%', // Added to ensure full width
    },
    tableWrapper: {
        overflowX: 'auto',
        width: '100%',
        maxWidth: '100%',
        padding: 0, // Added to match other components
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    deleted: {
        textDecoration: 'line-through',
        color: '#999',
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: '100%',
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'center',
        padding: theme.spacing(2),
        borderTop: '1px solid #e0e0e0',
    },
    actionButton: {
        margin: theme.spacing(0, 1),
        minWidth: '160px',
    }
});

class PhysicianLicenseEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            order: 'asc',
            orderBy: 'ltrLicenseType',
            page: 0,
            rowsPerPage: 5,
            showEditDlg: false,
            editLicense: null,
            deletedLicenses: [], // Store complete license objects
            formErrors: {},
            validationMessage: '',
            originalLicenses: props.licenses || [],
            pristineLicenses: props.licenses || [], // Never changes after initialization
            localChanges: [],
            hasLocalChanges: false,
            licenseTypes: [], // Will be populated from service
            statusOptions: [], // Will be populated from service
            stateOptions: [], // Will be populated from service
            changeTracking: [],
            // New state for changes summary dialog
            showChangesSummaryDialog: false,
            changesSummary: {
                newLicenses: [],
                modifiedLicenses: [],
                deletedLicenses: []
            },
            // Add state for delete confirmation dialog
            showDeleteConfirmDialog: false,
            licenseToDelete: null
        };
        this.dialogContentRef = React.createRef();
    }

    componentDidMount() {
        // Store the original licenses data
        this.setState({
            originalLicenses: [...this.props.licenses],
            pristineLicenses: [...this.props.licenses]
        });

        // Fetch license types, status options, and state options from services
        this.fetchLicenseOptions();

        // Expose methods to parent via ref
        if (this.props.forwardedRef) {
            this.props.forwardedRef.current = {
                validateForm: () => {
                    return true;
                },
                getFormData: () => {
                    // Generate a summary of changes for the parent
                    const changesSummary = this.generateChangesSummary();

                    // Get current licenses (with changes applied)
                    const currentLicenses = this.getCurrentLicenses();

                    return {
                        pristineObject: this.state.pristineLicenses,
                        modifiedObject: this.state.hasLocalChanges ? {
                            active: currentLicenses,
                            changes: changesSummary
                        } : null,
                        isValid: true
                    };
                }
            };
        }
    }

    componentDidUpdate(prevProps) {
        // Check if the licenses prop has changed
        if (prevProps.licenses !== this.props.licenses ||
            prevProps.filtered !== this.props.filtered) {

            // Update the local state if needed
            if (this.state.editLicense === null) {
                // Only update if we're not in the middle of editing
                this.setState({
                    page: 0, // Reset to first page when data changes
                });
            }
        }

        // If provider type changes, refetch license types
        if (prevProps.providerType !== this.props.providerType) {
            this.fetchLicenseTypes();
        }
    }

    fetchLicenseOptions = async () => {
        // Fetch all options in parallel
        await Promise.all([
            this.fetchLicenseTypes(),
            this.fetchLicenseStatus(),
            this.fetchStates()
        ]);
    }

    fetchLicenseTypes = async () => {
        try {
            // Get provider type from props or use a default value
            const prvType = 'P';

            // Fetch license types based on provider type
            const response = await ProviderService.getValidLicenseTypeForPrvType(prvType);
            if (response && response.data) {
                // Transform the data to include both the license type and state flag
                const licenseTypes = response.data.map(record => ({
                    type: record.ltrLicenseType,
                    stateRequired: record.ltrStateFlag === "Y"
                }));

                // Sort license types alphabetically
                licenseTypes.sort((a, b) => a.type.localeCompare(b.type));

                this.setState({ licenseTypes });
            } else {
                console.error('Error: No License Type data returned from service');
            }
        } catch (error) {
            console.error('Error fetching license types:', error);
        }
    }

    // Helper function to extract just the code part from license type
    getLicenseTypeCode = (licenseTypeString) => {
        if (!licenseTypeString) return '';
        // Assuming format is "CODE - Description"
        const parts = licenseTypeString.split(' - ');
        return parts[0] || licenseTypeString;
    }

    fetchLicenseStatus = async () => {
        try {
            // Fetch valid license statuses
            const response = await ProviderService.getValidLicenseStatus();
            if (response && response.data) {
                // Transform the data to the format we need
                const statusOptions = response.data.map(record => record.lsrStatus);
                this.setState({ statusOptions });
            } else {
                console.error('Error: No License Type data returned from service');
            }
        } catch (error) {
            console.error('Error fetching license status options:', error);
        }
    }

    fetchStates = async () => {
        try {
            // Fetch states and territories
            const response = await ProviderService.getStatesAndTerritories();
            if (response && response.data) {
                // Transform the data to include both code and name
                const stateOptions = response.data.map(record => ({
                    code: record.srStateCode,  // Use the state code
                    name: record.srStateName   // Keep the full name for display
                }));
                this.setState({ stateOptions });
            } else {
                console.error('Error: No state data returned from service');
            }
        } catch (error) {
            console.error('Error fetching states:', error);
        }
    }

    handleRequestSort = (event, property) => {
        const isDesc = this.state.orderBy === property && this.state.order === 'desc';
        this.setState({ order: isDesc ? 'asc' : 'desc', orderBy: property });
    }

    handleRequestFilter = (value, property) => {
        if (value.length < 1) {
            // Use the current source data, not the original filtered data
            this.props.setFilter(this.getCurrentLicenses())
            return true;
        } else {
            // Filter from the current source data
            this.props.setFilter(this.getCurrentLicenses().filter(license => {
                const testValue = license[property] !== null ? license[property].toString().toUpperCase() : license[property];
                if (testValue != null) {
                    this.setState({ page: 0 });
                    return testValue.search(value.toUpperCase()) !== -1;
                }
                return false;
            }))
        }
    }

    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage })
    }

    handleChangeRowsPerPage = event => {
        this.setState({ page: 0, rowsPerPage: event.target.value })
    }

    handleAddNewLicense = () => {
        // Clear any previous validation errors and message
        this.setState({
            formErrors: {},
            validationMessage: ''
        });

        // Create an empty license object with default values
        const newLicense = {
            plicId: `temp_${Date.now()}`, // Temporary ID until saved
            ltrLicenseType: '',
            plicStateCode: '',
            plicLicenseNbr: '',
            plicIssueDate: '',
            plicExpirationDate: '',
            lsrStatus: '',
            stateRequired: false, // Default to false until a license type is selected
            isNew: true // Flag to identify this is a new license
        };

        this.setState({
            editLicense: newLicense,
            showEditDlg: true
        });
    }

    // Helper method to ensure consistent date handling
    /*  parseDateString = (dateString) => {
         if (!dateString) return null;
 
         // Try to parse the date
         const date = new Date(dateString);
         if (isNaN(date.getTime())) return null;
 
         // Return a normalized YYYY-MM-DD string using UTC
         const year = date.getUTCFullYear();
         const month = String(date.getUTCMonth() + 1).padStart(2, '0');
         const day = String(date.getUTCDate()).padStart(2, '0');
 
         return `${year}-${month}-${day}`;
     } */

    parseDateString = (dateString) => {
        if (!dateString) return null;

        // Handle different date formats
        let parts;

        // If it's already in YYYY-MM-DD format
        if (dateString.includes('-')) {
            return dateString; // Already in the correct format, don't process further
        }

        // If it's in MM/DD/YYYY format
        if (dateString.includes('/')) {
            parts = dateString.split('/');
            if (parts.length === 3) {
                // Convert MM/DD/YYYY to YYYY-MM-DD
                const month = parts[0].padStart(2, '0');
                const day = parts[1].padStart(2, '0');
                const year = parts[2];
                return `${year}-${month}-${day}`;
            }
        }

        // If we can't parse it in a known format, try using Date but avoid timezone issues
        try {
            // Create date object and extract components directly without timezone conversion
            const date = new Date(dateString);
            if (isNaN(date.getTime())) return null;

            // Use local date components and manually format to YYYY-MM-DD
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');

            return `${year}-${month}-${day}`;
        } catch (e) {
            console.error("Error parsing date:", e);
            return null;
        }
    }
    /*  handleEditLicense = (license) => {
         // Clear any previous validation errors and message
         this.setState({
             formErrors: {},
             validationMessage: ''
         });
 
         // Find the license type to determine if state is required
         const selectedLicenseType = this.state.licenseTypes.find(
             lt => lt.type === license.ltrLicenseType
         );
         const stateRequired = selectedLicenseType ? selectedLicenseType.stateRequired : false;
 
         // Format the dates in the license object using the parseDateString method
         const formattedLicense = {
             ...license,
             plicIssueDate: this.parseDateString(license.plicIssueDate) || '',
             plicExpirationDate: this.parseDateString(license.plicExpirationDate) || '',
             stateRequired  // Add the stateRequired flag
         };
 
         // Log for debugging
         console.log("Original license dates:", {
             issueDate: license.plicIssueDate,
             expirationDate: license.plicExpirationDate
         });
         console.log("Formatted license dates:", {
             issueDate: formattedLicense.plicIssueDate,
             expirationDate: formattedLicense.plicExpirationDate
         });
 
         this.setState({
             editLicense: formattedLicense,
             showEditDlg: true
         });
     } */

    handleEditLicense = (license) => {
        // Clear any previous validation errors and message
        this.setState({
            formErrors: {},
            validationMessage: ''
        });

        // Find the license type to determine if state is required
        const selectedLicenseType = this.state.licenseTypes.find(
            lt => lt.type === license.ltrLicenseType
        );
        const stateRequired = selectedLicenseType ? selectedLicenseType.stateRequired : false;

        // Format the dates correctly without timezone conversion
        const formattedLicense = {
            ...license,
            plicIssueDate: license.plicIssueDate || '',
            plicExpirationDate: license.plicExpirationDate || '',
            stateRequired
        };

        // If dates are in MM/DD/YYYY format, convert to YYYY-MM-DD for the date input
        if (formattedLicense.plicIssueDate && formattedLicense.plicIssueDate.includes('/')) {
            const [month, day, year] = formattedLicense.plicIssueDate.split('/');
            formattedLicense.plicIssueDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
        }

        if (formattedLicense.plicExpirationDate && formattedLicense.plicExpirationDate.includes('/')) {
            const [month, day, year] = formattedLicense.plicExpirationDate.split('/');
            formattedLicense.plicExpirationDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
        }

        this.setState({
            editLicense: formattedLicense,
            showEditDlg: true
        });
    }
    // Helper function to compare two license objects
    areObjectsEqual = (obj1, obj2) => {
        // If either object is null or undefined, they're not equal
        if (!obj1 || !obj2) return false;

        // If both have plicId, compare them directly
        if (obj1.plicId && obj2.plicId) {
            return obj1.plicId === obj2.plicId;
        }

        // Otherwise fall back to field-by-field comparison
        const fieldsToCompare = [
            'ltrLicenseType',
            'plicStateCode',
            'plicLicenseNbr',
            'plicIssueDate',
            'plicExpirationDate',
            'lsrStatus'
        ];

        // Compare only the essential fields
        for (const field of fieldsToCompare) {
            // Special handling for dates
            if (field.includes('Date')) {
                // Normalize dates for comparison using parseDateString
                const date1 = this.parseDateString(obj1[field]);
                const date2 = this.parseDateString(obj2[field]);

                if (date1 !== date2) return false;
            }
            // Regular comparison for non-date fields
            else if (obj1[field] !== obj2[field]) {
                return false;
            }
        }

        return true;
    }

    handleConfirmDeleteLicense = (licenseToDelete) => {
        if (!licenseToDelete) return;

        // Check if this is a newly added license
        const isNewLicense = !this.state.pristineLicenses.some(
            lic => this.areObjectsEqual(lic, licenseToDelete)
        );

        this.setState({
            showDeleteConfirmDialog: true,
            licenseToDelete: licenseToDelete,
            isNewLicenseToDelete: isNewLicense
        });
    }

    // Modified to handle new licenses differently when deleting
    handleDeleteLicense = () => {
        const { licenseToDelete, isNewLicenseToDelete } = this.state;

        if (!licenseToDelete) return;

        if (isNewLicenseToDelete) {
            // For new licenses, completely remove them from tracking and display

            // First, remove from local changes if it exists there
            const updatedLocalChanges = this.state.localChanges.filter(
                change => !this.areObjectsEqual(change, licenseToDelete)
            );

            // Create updated licenses list without the new license
            const updatedLicenses = this.props.licenses.filter(
                license => !this.areObjectsEqual(license, licenseToDelete)
            );

            // Update state and notify parent
            this.setState({
                localChanges: updatedLocalChanges,
                hasLocalChanges: updatedLocalChanges.length > 0 || this.state.deletedLicenses.length > 0,
                showDeleteConfirmDialog: false,
                licenseToDelete: null,
                isNewLicenseToDelete: false
            }, () => {
                // Update the parent component with the filtered list
                if (this.props.updateLicenses) {
                    this.props.updateLicenses(updatedLicenses);
                } else if (this.props.setFilter) {
                    this.props.setFilter(updatedLicenses);
                }

                // Notify parent that this section has changes
                if (this.props.onSectionHasChanges) {
                    this.props.onSectionHasChanges(this.state.hasLocalChanges);
                }
            });
        } else {
            // For existing licenses, add to deletedLicenses array
            this.setState(prevState => ({
                deletedLicenses: [...prevState.deletedLicenses, licenseToDelete],
                hasLocalChanges: true,
                showDeleteConfirmDialog: false,
                licenseToDelete: null,
                isNewLicenseToDelete: false
            }));

            // Notify parent component of the deletion
            if (this.props.onChange) {
                this.props.onChange('delete', licenseToDelete, licenseToDelete);
            }

            // Notify parent that this section has unsaved changes
            if (this.props.onSectionHasChanges) {
                this.props.onSectionHasChanges(true);
            }
        }
    }

    // Add method to cancel deletion
    handleCancelDelete = () => {
        this.setState({
            showDeleteConfirmDialog: false,
            licenseToDelete: null
        });
    }

    handleUndoDelete = (licenseToUndo) => {
        // Remove the license from the deleted list by comparing the entire object
        this.setState(prevState => {
            const updatedDeletedLicenses = prevState.deletedLicenses.filter(
                deletedLicense => !this.areObjectsEqual(deletedLicense, licenseToUndo)
            );

            // Check if there are still changes after this undo
            const stillHasChanges = updatedDeletedLicenses.length > 0 || prevState.localChanges.length > 0;

            return {
                deletedLicenses: updatedDeletedLicenses,
                hasLocalChanges: stillHasChanges
            };
        });

        // Notify parent component of the undo
        if (this.props.onChange) {
            this.props.onChange('add', licenseToUndo, null);
        }

        // Notify parent that this section has changes (or no changes)
        if (this.props.onSectionHasChanges) {
            this.setState(prevState => {
                const stillHasChanges = prevState.deletedLicenses.length > 0 || prevState.localChanges.length > 0;
                this.props.onSectionHasChanges(stillHasChanges);
                return null; // No state update needed
            });
        }
    }

    isLicenseDeleted = (license) => {
        // Compare each field of the license to check if it's marked for deletion
        return this.state.deletedLicenses.some(deletedLicense =>
            this.areObjectsEqual(deletedLicense, license)
        );
    }

    closeEditDlg = () => {
        this.setState({
            editLicense: null,
            showEditDlg: false,
            formErrors: {},
            validationMessage: ''
        });
    }

    handleInputChange = (e) => {
        const { name, value } = e.target;

        // For license number, enforce character limit
        if (name === 'plicLicenseNbr' && value.length > 30) {
            return; // Don't update state if exceeding limit
        }

        this.setState(prevState => {
            const updatedLicense = {
                ...prevState.editLicense,
                [name]: value
            };

            // If license type changed, update the state requirement flag
            if (name === 'ltrLicenseType') {
                const selectedLicenseType = this.state.licenseTypes.find(lt => lt.type === value);
                updatedLicense.stateRequired = selectedLicenseType ? selectedLicenseType.stateRequired : false;
            }

            return {
                editLicense: updatedLicense
            };
        });
    }

    validateLicense = (license) => {
        const errors = {};

        if (!license.ltrLicenseType || license.ltrLicenseType.trim() === '') {
            errors.ltrLicenseType = 'License type is required';
        }

        // Find the selected license type to check if state is required
        const selectedLicenseType = this.state.licenseTypes.find(
            lt => lt.type === license.ltrLicenseType
        );
        const isStateRequired = selectedLicenseType ? selectedLicenseType.stateRequired : false;

        // State validation (conditionally required)
        if (isStateRequired && (!license.plicStateCode || license.plicStateCode.trim() === '')) {
            errors.plicStateCode = 'State is required for this license type';
        }

        // License Number validation (optional, max 30 chars)
        if (license.plicLicenseNbr && license.plicLicenseNbr.trim().length > 30) {
            errors.plicLicenseNbr = 'License number cannot exceed 30 characters';
        }

        // Parse dates using the parseDateString method
        const issueDate = license.plicIssueDate ? this.parseDateString(license.plicIssueDate) : null;
        const expirationDate = license.plicExpirationDate ? this.parseDateString(license.plicExpirationDate) : null;

        // Only validate issue date format if it's provided
        if (license.plicIssueDate && !issueDate) {
            errors.plicIssueDate = 'Please enter a valid date';
        }

        // Only validate expiration date format if it's provided
        if (license.plicExpirationDate && !expirationDate) {
            errors.plicExpirationDate = 'Please enter a valid date';
        }

        // Check if expiration date is after issue date (only if both are provided)
        if (issueDate && expirationDate && expirationDate < issueDate) {
            errors.plicExpirationDate = 'Expiration date must be after issue date';
        }

        return {
            isValid: Object.keys(errors).length === 0,
            errors
        };
    }

    /*  handleSaveEdit = () => {
        const license = this.state.editLicense;

        // Validate the license
        const { isValid, errors } = this.validateLicense(license);

        if (!isValid) {
            // Update state with errors and validation message
            this.setState({
                formErrors: errors,
                validationMessage: 'Please fix the validation errors before saving.'
            });

            // Scroll to the top of the dialog
            if (this.dialogContentRef && this.dialogContentRef.current) {
                this.dialogContentRef.current.scrollTop = 0;
            }

            return;
        }

        // Clear any previous errors and message
        this.setState({
            formErrors: {},
            validationMessage: ''
        });

        // Create updated license
        const updatedLicense = { ...license };

        // Remove the isNew flag
        delete updatedLicense.isNew;

        // Track this change locally
        this.trackLocalChange(updatedLicense);

        // Determine if this is a new license or an edit
        const action = license.isNew ? 'add' : 'edit';

        // Find the original license data for edits
        let originalData = null;
        if (action === 'edit') {
            originalData = this.state.originalLicenses.find(
                lic => lic.plicId === updatedLicense.plicId
            );
        }

        // Notify parent component of the change
        if (this.props.onChange) {
            this.props.onChange(action, updatedLicense, originalData);
        }

        // Create a new array with all the current licenses
        let updatedLicenses = [...this.props.licenses];

        if (license.isNew) {
            // For new licenses, add to the array
            updatedLicenses.push(updatedLicense);
        } else {
            // For existing licenses, update in the array
            const index = updatedLicenses.findIndex(lic => lic.plicId === updatedLicense.plicId);
            if (index !== -1) {
                updatedLicenses[index] = updatedLicense;
            }
        }

        // Update both the source data and filtered view
        if (this.props.updateLicenses) {
            this.props.updateLicenses(updatedLicenses);
        } else if (this.props.setFilter) {
            // Fallback to just updating the filter if updateLicenses isn't available
            this.props.setFilter(updatedLicenses);
        }

        // Update the local state for the table display
        this.setState({
            editLicense: null,
            showEditDlg: false,
            hasLocalChanges: true
        });

        // Notify parent that this section has unsaved changes
        if (this.props.onSectionHasChanges) {
            this.props.onSectionHasChanges(true);
        }
    }  */


    handleSaveEdit = () => {
        const license = this.state.editLicense;

        // Validate the license
        const { isValid, errors } = this.validateLicense(license);

        if (!isValid) {
            // Update state with errors and validation message
            this.setState({
                formErrors: errors,
                validationMessage: 'Please fix the validation errors before saving.'
            });

            // Scroll to the top of the dialog
            if (this.dialogContentRef && this.dialogContentRef.current) {
                this.dialogContentRef.current.scrollTop = 0;
            }

            return;
        }

        // Clear any previous errors and message
        this.setState({
            formErrors: {},
            validationMessage: ''
        });

        // Create updated license - IMPORTANT: preserve date formats exactly as entered
        const updatedLicense = { ...license };

        // Remove the isNew flag
        delete updatedLicense.isNew;

        // Track this change locally
        this.trackLocalChange(updatedLicense);

        // Determine if this is a new license or an edit
        const action = license.isNew ? 'add' : 'edit';

        // Find the original license data for edits
        let originalData = null;
        if (action === 'edit') {
            originalData = this.state.originalLicenses.find(
                lic => lic.plicId === updatedLicense.plicId
            );
        }

        // Notify parent component of the change
        if (this.props.onChange) {
            this.props.onChange(action, updatedLicense, originalData);
        }

        // Create a new array with all the current licenses
        let updatedLicenses = [...this.props.licenses];

        if (license.isNew) {
            // For new licenses, add to the array
            updatedLicenses.push(updatedLicense);
        } else {
            // For existing licenses, update in the array
            const index = updatedLicenses.findIndex(lic => lic.plicId === updatedLicense.plicId);
            if (index !== -1) {
                updatedLicenses[index] = updatedLicense;
            }
        }

        // Update both the source data and filtered view
        if (this.props.updateLicenses) {
            this.props.updateLicenses(updatedLicenses);
        } else if (this.props.setFilter) {
            // Fallback to just updating the filter if updateLicenses isn't available
            this.props.setFilter(updatedLicenses);
        }

        // Update the local state for the table display
        this.setState({
            editLicense: null,
            showEditDlg: false,
            hasLocalChanges: true
        });

        // Notify parent that this section has unsaved changes
        if (this.props.onSectionHasChanges) {
            this.props.onSectionHasChanges(true);
        }
    }
    trackLocalChange = (license) => {
        this.setState(prevState => {
            // Check if this license is already in the localChanges array
            const existingIndex = prevState.localChanges.findIndex(
                change => change.plicId === license.plicId
            );

            let newLocalChanges;
            if (existingIndex !== -1) {
                // Update existing change
                newLocalChanges = [...prevState.localChanges];
                newLocalChanges[existingIndex] = license;
            } else {
                // Add new change
                newLocalChanges = [...prevState.localChanges, license];
            }

            return {
                localChanges: newLocalChanges
            };
        });
    }

    // Generate changes summary for review
    generateChangesSummary = () => {
        const { localChanges, deletedLicenses, originalLicenses } = this.state;

        // Track changes
        const summary = {
            newLicenses: [],
            modifiedLicenses: [],
            deletedLicenses: []
        };

        // Find new and modified licenses
        localChanges.forEach(license => {
            const original = originalLicenses.find(lic => lic.plicId === license.plicId);

            if (!original) {
                // New license
                summary.newLicenses.push(license);
            } else {
                // Modified license
                summary.modifiedLicenses.push({
                    original,
                    modified: license
                });
            }
        });

        // Add deleted licenses (but only existing ones, not newly added ones)
        summary.deletedLicenses = deletedLicenses.filter(license => {
            // Only include licenses that were in the original data
            return originalLicenses.some(orig => orig.plicId === license.plicId);
        });

        return summary;
    }

    // Handle showing changes summary dialog
    // Handle showing changes summary dialog
    handleShowChanges = () => {
        // If there are no changes, do nothing
        if (!this.state.hasLocalChanges) {
            return;
        }

        // Generate a summary of changes for the dialog
        const changesSummary = this.generateChangesSummary();

        // Show the changes summary dialog
        this.setState({
            changesSummary,
            showChangesSummaryDialog: true
        });


    }

    // Add method to close the changes summary dialog
    handleCloseChangesSummary = () => {
        this.setState({ showChangesSummaryDialog: false });
    }

    // Get current licenses with all changes applied
    getCurrentLicenses = () => {
        // Start with original licenses
        let currentLicenses = JSON.parse(JSON.stringify(this.state.originalLicenses));

        // Apply all tracked changes
        this.state.localChanges.forEach(modifiedLicense => {
            // Find the license by plicId
            const index = currentLicenses.findIndex(lic => lic.plicId === modifiedLicense.plicId);

            if (index !== -1) {
                // Update existing license
                currentLicenses[index] = modifiedLicense;
            } else {
                // Add new license
                currentLicenses.push(modifiedLicense);
            }
        });

        // Remove deleted licenses
        currentLicenses = currentLicenses.filter(license =>
            !this.state.deletedLicenses.some(deletedLicense => deletedLicense.plicId === license.plicId)
        );

        return currentLicenses;
    }

    handleDiscardChanges = () => {
        // Reset to original data
        if (this.props.setFilter) {
            this.props.setFilter(this.state.pristineLicenses);
        }

        // Clear local changes and deleted licenses
        this.setState({
            localChanges: [],
            deletedLicenses: [],
            hasLocalChanges: false,
            originalLicenses: [...this.state.pristineLicenses]
        });

        // Notify parent component about discarded changes
        if (this.props.onSectionDiscardChanges) {
            this.props.onSectionDiscardChanges({
                pristineObject: this.state.pristineLicenses,
                modifiedObject: null
            });
        }

        // Notify parent that this section no longer has unsaved changes
        if (this.props.onSectionHasChanges) {
            this.props.onSectionHasChanges(false);
        }
    }

    /*  formatDate = (dateString) => {
         if (!dateString) return '';
 
         // Use parseDateString to get normalized date
         const normalizedDate = this.parseDateString(dateString);
         if (!normalizedDate) return dateString; // Return original if invalid
 
         // Split the normalized date (YYYY-MM-DD) and rearrange for display
         const [year, month, day] = normalizedDate.split('-');
         return `${month}/${day}/${year}`;
     } */

    // Also update the formatDate method to avoid timezone issues
    formatDate = (dateString) => {
        if (!dateString) return '';

        // If it's in YYYY-MM-DD format, convert to MM/DD/YYYY for display
        if (dateString.includes('-')) {
            const [year, month, day] = dateString.split('-');
            return `${month}/${day}/${year}`;
        }

        // If it's already in another format, try to standardize it
        try {
            // Create a date without timezone conversion
            const parts = dateString.split(/[-\/]/);
            if (parts.length === 3) {
                // Try to determine format based on part sizes
                let year, month, day;

                // If first part is 4 digits, assume YYYY-MM-DD
                if (parts[0].length === 4) {
                    [year, month, day] = parts;
                }
                // If last part is 4 digits, assume MM/DD/YYYY
                else if (parts[2].length === 4) {
                    [month, day, year] = parts;
                }
                // Default assumption
                else {
                    [month, day, year] = parts;
                }

                return `${month}/${day}/${year}`;
            }

            // Fallback to original string if we can't parse it
            return dateString;
        } catch (e) {
            console.error("Error formatting date:", e);
            return dateString;
        }
    }

    // Helper method to get display name for fields
    getFieldDisplayName(field) {
        const fieldDisplayNames = {
            ltrLicenseType: 'License Type',
            plicStateCode: 'State',
            plicLicenseNbr: 'License Number',
            plicIssueDate: 'Issue Date',
            plicExpirationDate: 'Expiration Date',
            lsrStatus: 'Status'
        };

        return fieldDisplayNames[field] || field;
    }

    render() {
        const { classes } = this.props;
        const {
            editLicense,
            showEditDlg,
            licenseTypes,
            statusOptions,
            stateOptions,
            licenseToDelete,
            showDeleteConfirmDialog
        } = this.state;

        return (
            <div className="cvsTable" style={{ width: '100%', maxWidth: '100%' }}>
                {/* Edit License Dialog */}
                <Dialog
                    open={showEditDlg}
                    onClose={this.closeEditDlg}
                    aria-labelledby="edit-dialog-title"
                    aria-describedby="edit-dialog-description"
                    fullWidth
                    maxWidth="md"
                >
                    <DialogTitle id="edit-dialog-title">
                        {editLicense?.isNew ? "Add New License" : "Edit License"}
                    </DialogTitle>

                    <DialogContent ref={this.dialogContentRef}>
                        {/* Validation message */}
                        {this.state.validationMessage && (
                            <div style={{
                                backgroundColor: '#f8d7da',
                                color: '#721c24',
                                padding: '12px',
                                borderRadius: '4px',
                                marginBottom: '16px',
                                border: '1px solid #f5c6cb'
                            }}>
                                <Typography variant="body2" style={{ fontWeight: 500 }}>
                                    {this.state.validationMessage}
                                </Typography>
                            </div>
                        )}

                        {editLicense && (
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        name="ltrLicenseType"
                                        label="License Type"
                                        value={editLicense.ltrLicenseType || ''}
                                        onChange={this.handleInputChange}
                                        fullWidth
                                        margin="normal"
                                        variant="outlined"
                                        select
                                        error={!!this.state.formErrors?.ltrLicenseType}
                                        helperText={this.state.formErrors?.ltrLicenseType || "Required"}
                                        required
                                    >
                                        <MenuItem value="">Select License Type</MenuItem>
                                        {licenseTypes.map(typeObj => (
                                            <MenuItem key={typeObj.type} value={typeObj.type}>{typeObj.type}</MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        name="plicStateCode"
                                        label="State"
                                        value={editLicense.plicStateCode || ''}
                                        onChange={this.handleInputChange}
                                        fullWidth
                                        margin="normal"
                                        variant="outlined"
                                        select
                                        error={!!this.state.formErrors?.plicStateCode}
                                        helperText={this.state.formErrors?.plicStateCode ||
                                            (editLicense.stateRequired ? "Required" : "Optional")}
                                        required={editLicense.stateRequired}
                                    >
                                        <MenuItem value="">Select State</MenuItem>
                                        {stateOptions.map(state => (
                                            <MenuItem key={state.code} value={state.code}>
                                                {state.code} - {state.name}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>

                                <Grid item xs={12}>
                                    <TextField
                                        name="plicLicenseNbr"
                                        label="License Number"
                                        value={editLicense.plicLicenseNbr || ''}
                                        onChange={this.handleInputChange}
                                        fullWidth
                                        margin="normal"
                                        variant="outlined"
                                        error={!!this.state.formErrors?.plicLicenseNbr}
                                        helperText={this.state.formErrors?.plicLicenseNbr || "Optional (max 30 characters)"}
                                        inputProps={{
                                            maxLength: 30 // Add character limit
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        name="plicIssueDate"
                                        label="Issue Date"
                                        type="date"
                                        value={editLicense.plicIssueDate || ''}
                                        onChange={this.handleInputChange}
                                        fullWidth
                                        margin="normal"
                                        variant="outlined"
                                        error={!!this.state.formErrors?.plicIssueDate}
                                        helperText={this.state.formErrors?.plicIssueDate || "Optional"}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        name="plicExpirationDate"
                                        label="Expiration Date"
                                        type="date"
                                        value={editLicense.plicExpirationDate || ''}
                                        onChange={this.handleInputChange}
                                        fullWidth
                                        margin="normal"
                                        variant="outlined"
                                        error={!!this.state.formErrors?.plicExpirationDate}
                                        helperText={this.state.formErrors?.plicExpirationDate || "Optional"}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        name="lsrStatus"
                                        label="Status"
                                        value={editLicense.lsrStatus || ''}
                                        onChange={this.handleInputChange}
                                        fullWidth
                                        margin="normal"
                                        variant="outlined"
                                        select
                                        error={!!this.state.formErrors?.lsrStatus}
                                        helperText={this.state.formErrors?.lsrStatus || "Optional"}
                                        SelectProps={{
                                            displayEmpty: true, // This ensures the placeholder is shown
                                            renderValue: (selected) => {
                                                if (!selected) {
                                                    return "Select Status"; // Placeholder text in normal font
                                                }
                                                return selected;
                                            }
                                        }}
                                    >
                                        <MenuItem value="">
                                            Select Status
                                        </MenuItem>
                                        {statusOptions.map(status => (
                                            <MenuItem key={status} value={status}>{status}</MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>
                            </Grid>
                        )}
                    </DialogContent>

                    <DialogActions>
                        <Button onClick={this.closeEditDlg} aria-label="Cancel edit" variant="outlined"
                            color="primary">
                            Cancel
                        </Button>
                        <Button
                            onClick={this.handleSaveEdit}
                            color="primary"
                            variant="contained"
                            aria-label="Save license changes"
                        >
                            Save
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* Delete Confirmation Dialog using the reusable component */}
                <ConfirmationDialog
                    open={showDeleteConfirmDialog}
                    title="Confirm Delete License"
                    message={this.state.isNewLicenseToDelete
                        ? "Are you sure you want to delete this newly added license?"
                        : "Are you sure you want to delete this license?"}
                    detailsComponent={
                        licenseToDelete && (
                            <>
                                {this.state.isNewLicenseToDelete && (
                                    <Typography variant="subtitle2" style={{ color: '#f44336', marginBottom: '8px' }}>
                                        <strong>This is a newly added license that hasn't been saved.</strong>
                                    </Typography>
                                )}
                                <Typography variant="subtitle2">
                                    <strong>Type:</strong> {licenseToDelete.ltrLicenseType}
                                </Typography>
                                <Typography variant="subtitle2">
                                    <strong>State:</strong> {licenseToDelete.plicStateCode}
                                </Typography>
                                <Typography variant="subtitle2">
                                    <strong>License Number:</strong> {licenseToDelete.plicLicenseNbr}
                                </Typography>
                                <Typography variant="subtitle2">
                                    <strong>Expiration Date:</strong> {this.formatDate(licenseToDelete.plicExpirationDate)}
                                </Typography>
                            </>
                        )
                    }
                    onConfirm={this.handleDeleteLicense}
                    onCancel={this.handleCancelDelete}
                    confirmText="Delete"
                    confirmColor="secondary"
                    severity="error"
                />

                {/* Changes Summary Dialog */}
                <Dialog
                    open={this.state.showChangesSummaryDialog}
                    onClose={this.handleCloseChangesSummary}
                    maxWidth="md"
                    fullWidth
                >
                    <DialogTitle>
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Typography variant="h6">Review License Changes</Typography>
                        </Box>
                    </DialogTitle>
                    <DialogContent>
                        {this.state.changesSummary.newLicenses.length === 0 &&
                            this.state.changesSummary.modifiedLicenses.length === 0 &&
                            this.state.changesSummary.deletedLicenses.length === 0 ? (
                            <Typography>No changes to review.</Typography>
                        ) : (
                            <div>
                                {/* New Licenses Section */}
                                {this.state.changesSummary.newLicenses.length > 0 && (
                                    <div style={{ marginBottom: '20px' }}>
                                        <Typography variant="subtitle1" style={{ fontWeight: 'bold', color: '#4caf50', marginBottom: '8px' }}>
                                            New Licenses ({this.state.changesSummary.newLicenses.length})
                                        </Typography>
                                        <div style={{ overflowX: 'auto', width: '100%' }}>
                                            <Table size="small" style={{ width: '100%' }}>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell style={{ fontWeight: 'bold' }}>Type</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold' }}>State</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold' }}>License Number</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold' }}>Issue Date</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold' }}>Expiration Date</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold' }}>Status</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {this.state.changesSummary.newLicenses.map((license, index) => (
                                                        <TableRow key={`new-${index}`} style={{ backgroundColor: '#e8f5e9' }}>
                                                            <TableCell>{license.ltrLicenseType}</TableCell>
                                                            <TableCell>{license.plicStateCode}</TableCell>
                                                            <TableCell>{license.plicLicenseNbr}</TableCell>
                                                            <TableCell>{this.formatDate(license.plicIssueDate)}</TableCell>
                                                            <TableCell>{this.formatDate(license.plicExpirationDate)}</TableCell>
                                                            <TableCell>{license.lsrStatus}</TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </div>
                                    </div>
                                )}

                                {/* Modified Licenses Section - UPDATED to show highlighted changes */}
                                {this.state.changesSummary.modifiedLicenses.length > 0 && (
                                    <div style={{ marginBottom: '20px' }}>
                                        <Typography variant="subtitle1" style={{ fontWeight: 'bold', color: '#2196f3', marginBottom: '8px' }}>
                                            Modified Licenses ({this.state.changesSummary.modifiedLicenses.length})
                                        </Typography>

                                        {/* Added explanation message */}
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                marginBottom: '8px',
                                                backgroundColor: '#e3f2fd',
                                                padding: '6px 12px',
                                                borderRadius: '4px'
                                            }}
                                        >
                                            <span
                                                style={{
                                                    display: 'inline-block',
                                                    width: '16px',
                                                    height: '16px',
                                                    backgroundColor: '#ffeb3b40',
                                                    border: '1px solid #ffeb3b',
                                                    marginRight: '8px',
                                                    borderRadius: '2px'
                                                }}
                                            ></span>
                                            <Typography variant="body2" style={{ fontStyle: 'italic' }}>
                                                Highlighted values indicate modified fields
                                            </Typography>
                                        </Box>

                                        <div style={{ overflowX: 'auto', width: '100%' }}>
                                            <Table size="small" style={{ width: '100%' }}>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell style={{ fontWeight: 'bold' }}>Type</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold' }}>State</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold' }}>License Number</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold' }}>Issue Date</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold' }}>Expiration Date</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold' }}>Status</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {this.state.changesSummary.modifiedLicenses.map((change, index) => {
                                                        // Helper function to determine if a field has changed
                                                        const hasChanged = (field) => {
                                                            // Special handling for dates
                                                            if (field.includes('Date')) {
                                                                const origDate = this.parseDateString(change.original[field]);
                                                                const modDate = this.parseDateString(change.modified[field]);
                                                                return origDate !== modDate;
                                                            }

                                                            return change.original[field] !== change.modified[field];
                                                        };

                                                        // Style for changed values
                                                        const changedStyle = {
                                                            backgroundColor: '#ffeb3b40',
                                                            fontWeight: 'bold'
                                                        };

                                                        return (
                                                            <TableRow key={`mod-${index}`} style={{ backgroundColor: '#e3f2fd' }}>
                                                                <TableCell style={hasChanged('ltrLicenseType') ? changedStyle : {}}>
                                                                    {change.modified.ltrLicenseType}
                                                                </TableCell>
                                                                <TableCell style={hasChanged('plicStateCode') ? changedStyle : {}}>
                                                                    {change.modified.plicStateCode}
                                                                </TableCell>
                                                                <TableCell style={hasChanged('plicLicenseNbr') ? changedStyle : {}}>
                                                                    {change.modified.plicLicenseNbr}
                                                                </TableCell>
                                                                <TableCell style={hasChanged('plicIssueDate') ? changedStyle : {}}>
                                                                    {this.formatDate(change.modified.plicIssueDate)}
                                                                </TableCell>
                                                                <TableCell style={hasChanged('plicExpirationDate') ? changedStyle : {}}>
                                                                    {this.formatDate(change.modified.plicExpirationDate)}
                                                                </TableCell>
                                                                <TableCell style={hasChanged('lsrStatus') ? changedStyle : {}}>
                                                                    {change.modified.lsrStatus}
                                                                </TableCell>
                                                            </TableRow>
                                                        );
                                                    })}
                                                </TableBody>
                                            </Table>
                                        </div>
                                    </div>
                                )}

                                {/* Deleted Licenses Section */}
                                {this.state.changesSummary.deletedLicenses.length > 0 && (
                                    <div style={{ marginBottom: '20px' }}>
                                        <Typography variant="subtitle1" style={{ fontWeight: 'bold', color: '#f44336', marginBottom: '8px' }}>
                                            Deleted Licenses ({this.state.changesSummary.deletedLicenses.length})
                                        </Typography>
                                        <div style={{ overflowX: 'auto', width: '100%' }}>
                                            <Table size="small" style={{ width: '100%' }}>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell style={{ fontWeight: 'bold' }}>Type</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold' }}>State</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold' }}>License Number</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold' }}>Issue Date</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold' }}>Expiration Date</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold' }}>Status</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {this.state.changesSummary.deletedLicenses.map((license, index) => (
                                                        <TableRow key={`del-${index}`} style={{ backgroundColor: '#ffebee' }}>
                                                            <TableCell>{license.ltrLicenseType}</TableCell>
                                                            <TableCell>{license.plicStateCode}</TableCell>
                                                            <TableCell>{license.plicLicenseNbr}</TableCell>
                                                            <TableCell>{this.formatDate(license.plicIssueDate)}</TableCell>
                                                            <TableCell>{this.formatDate(license.plicExpirationDate)}</TableCell>
                                                            <TableCell>{license.lsrStatus}</TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseChangesSummary} variant="outlined">
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>

                <div className={classes.root} style={{ width: '100%', maxWidth: '100%' }}>
                    <Paper className={classes.paper} style={{ width: '100%' }}>
                        {/* Combined row for Add License button and pagination */}
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            padding: '8px 16px',
                            width: '100%'
                        }}>
                            {/* Left side - Add License button */}
                            <div>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={this.handleAddNewLicense}
                                    startIcon={<AddIcon />}
                                    aria-label="Add new license"
                                >
                                    Add License
                                </Button>
                            </div>

                            {/* Right side - Pagination */}
                            <div>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25, 50, 100, 200]}
                                    component="div"
                                    count={this.props.licenses.length}
                                    rowsPerPage={this.state.rowsPerPage}
                                    page={this.state.page}
                                    ActionsComponent={TablePaginationActions}
                                    onChangePage={this.handleChangePage}
                                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                    style={{ marginRight: '-16px' }} // Adjust to align with table edge
                                />
                            </div>
                        </div>

                        <div className={classes.tableWrapper} style={{ width: '100%', maxWidth: '100%' }}>
                            <Table
                                className={`${classes.table} App-font`}
                                aria-labelledby="tableTitle"
                                size='small'
                                striped
                                aria-label="License List table"
                                style={{ width: '100%' }}
                            >
                                <EnhancedTableHead
                                    classes={classes}
                                    order={this.state.order}
                                    orderBy={this.state.orderBy}
                                    onRequestSort={this.handleRequestSort}
                                    onRequestFilter={this.handleRequestFilter}
                                    rowCount={this.props.licenses.length}
                                />
                                <TableBody className="Demographic">
                                    {stableSort(this.props.licenses, getSorting(this.state.order, this.state.orderBy))
                                        .slice(this.state.page * this.state.rowsPerPage, this.state.page * this.state.rowsPerPage + this.state.rowsPerPage)
                                        .map((row, index) => {
                                            const labelId = `enhanced-table-Select-${index}`;
                                            // Check if this specific row is marked for deletion
                                            const isDeleted = this.isLicenseDeleted(row);

                                            return (
                                                <TableRow
                                                    tabIndex={-1}
                                                    key={row.plicId || index}
                                                    style={{
                                                        padding: '5px 20px',
                                                        height: 25,
                                                        backgroundColor: index % 2 ? '#fafafa' : 'white',
                                                        opacity: isDeleted ? 0.7 : 1
                                                    }}
                                                >
                                                    <TableCell component="th" id={labelId} scope="row" size='small'
                                                        className={isDeleted ? classes.deleted : ''}
                                                        style={{ width: '15%' }}>
                                                        {this.getLicenseTypeCode(row.ltrLicenseType)}
                                                    </TableCell>
                                                    <TableCell component="th" id={labelId} scope="row" size='small'
                                                        className={isDeleted ? classes.deleted : ''}
                                                        style={{ width: '10%' }}>
                                                        {row.plicStateCode}
                                                    </TableCell>
                                                    <TableCell component="th" id={labelId} scope="row" size='small'
                                                        className={isDeleted ? classes.deleted : ''}
                                                        style={{ width: '15%' }}>
                                                        {row.plicLicenseNbr}
                                                    </TableCell>
                                                    <TableCell component="th" id={labelId} scope="row" size='small'
                                                        className={isDeleted ? classes.deleted : ''}
                                                        style={{ width: '15%' }}>
                                                        {this.formatDate(row.plicIssueDate)}
                                                    </TableCell>
                                                    <TableCell component="th" id={labelId} scope="row" size='small'
                                                        className={isDeleted ? classes.deleted : ''}
                                                        style={{ width: '15%' }}>
                                                        {this.formatDate(row.plicExpirationDate)}
                                                    </TableCell>
                                                    <TableCell component="th" id={labelId} scope="row" size='small'
                                                        className={isDeleted ? classes.deleted : ''}
                                                        style={{ width: '15%' }}>
                                                        {row.lsrStatus}
                                                    </TableCell>
                                                    <TableCell component="th" id={labelId} scope="row" size='small'
                                                        style={{ width: '15%' }}>
                                                        {isDeleted ? (
                                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                <Tooltip title="Restore">
                                                                    <IconButton
                                                                        size="small"
                                                                        onClick={() => this.handleUndoDelete(row)}
                                                                        aria-label="restore license"
                                                                        color="primary"
                                                                    >
                                                                        <RestoreIcon fontSize="small" />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </div>
                                                        ) : (
                                                            <>
                                                                <Tooltip title="Edit License">
                                                                    <IconButton
                                                                        aria-label="edit license"
                                                                        onClick={() => this.handleEditLicense(row)}
                                                                        size="small"
                                                                    >
                                                                        <EditIcon fontSize="small" />
                                                                    </IconButton>
                                                                </Tooltip>
                                                                <Tooltip title="Delete License">
                                                                    <IconButton
                                                                        aria-label="delete license"
                                                                        onClick={() => this.handleConfirmDeleteLicense(row)}
                                                                        size="small"
                                                                    >
                                                                        <DeleteIcon fontSize="small" />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </>
                                                        )}
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                </TableBody>
                            </Table>
                        </div>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            padding: '8px 16px',
                            width: '100%'
                        }}>
                            {/* Left side - empty to match layout */}
                            <div>
                                {/* This space intentionally left empty to match the layout of the top bar */}
                            </div>

                            {/* Right side - Pagination */}
                            <div>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25, 50, 100, 200]}
                                    component="div"
                                    count={this.props.licenses.length}
                                    rowsPerPage={this.state.rowsPerPage}
                                    page={this.state.page}
                                    ActionsComponent={TablePaginationActions}
                                    onChangePage={this.handleChangePage}
                                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                    style={{ marginRight: '-16px' }} // Adjust to align with table edge
                                />
                            </div>
                        </div>
                        {/* Updated buttons below the table with center alignment */}
                        <div className={classes.buttonContainer}>
                            <Button
                                variant="outlined"
                                onClick={this.handleDiscardChanges}
                                startIcon={<UndoIcon />}
                                aria-label="Discard all changes"
                                className={classes.actionButton}
                                disabled={!this.state.hasLocalChanges}
                            >
                                Discard Changes
                            </Button>

                            <Button
                                variant="contained"
                                color="primary"
                                onClick={this.handleShowChanges}
                                startIcon={<VisibilityIcon />}
                                aria-label="Review changes"
                                className={classes.actionButton}
                                disabled={!this.state.hasLocalChanges}
                            >
                                Review Changes
                            </Button>
                        </div>
                    </Paper>
                </div>
            </div>
        );
    }
}

PhysicianLicenseEdit.propTypes = {
    classes: PropTypes.object.isRequired,
    licenses: PropTypes.array.isRequired,
    setFilter: PropTypes.func.isRequired,
    filtered: PropTypes.array.isRequired,
    updateLicenses: PropTypes.func,
    onChange: PropTypes.func,
    providerType: PropTypes.string, // Added prop for provider type
    forwardedRef: PropTypes.object,
    onSectionSaveLocal: PropTypes.func,
    onSectionDiscardChanges: PropTypes.func,
    onSectionHasChanges: PropTypes.func
};

// Create a wrapper component that uses forwardRef
const ForwardedPhysicianLicenseEdit = React.forwardRef((props, ref) => {
    return <PhysicianLicenseEdit {...props} forwardedRef={ref} />;
});

export default withStyles(useStyles)(ForwardedPhysicianLicenseEdit);